<template>
  <div class="user-change-password">
    <Form ref="form" v-slot="{ handleSubmit }" :validation-schema="schema" as="div">
      <div class="uq-stripe-form-container row text-white">
        <div class="form-group col-12 mb-16 ">
          <label class="text-xs mb-5">{{ trans.oldPassword }}</label>

          <div class="button position-relative">
            <Field
              id="oldPassword"
              v-model="subscriberInformation.oldPassword"
              :type="showOldPassword ? 'text' : 'password'"
              aria-describedby="oldPassword"
              class="form-control position-relative"
              name="oldPassword"
            />

            <button :disabled="subscriberInformation.oldPassword.length <= 0"
                    class="btn p-8 password-button"
                    @click="showOldPassword = !showOldPassword">

            <span :class="{'icon-eye-hide': showOldPassword,'icon-eye': !showOldPassword}"
                  class="icon"></span>
            </button>
          </div>

          <ErrorMessage class="invalid-feedback" name="oldPassword"/>
        </div>

        <div class="form-group col-12 mb-16">
          <label class="text-xs mb-5">{{ trans.newPassword }}</label>

          <div class="button position-relative">
            <Field
              id="newPassword"
              v-model="subscriberInformation.newPassword"
              :type="showNewPassword ? 'text' : 'password'"
              aria-describedby="newPassword"
              class="form-control"
              name="newPassword"
              type="password"
            />
            <button :disabled="subscriberInformation.newPassword.length <= 0"
                    class="btn p-8 password-button"
                    @click="showNewPassword = !showNewPassword">

            <span :class="{'icon-eye-hide': showNewPassword,'icon-eye': !showNewPassword}"
                  class="icon"></span>
            </button>
          </div>
          <ErrorMessage class="invalid-feedback" name="newPassword"/>
        </div>

        <div class="form-group col-12 mb-16">
          <label class="text-xs mb-5">{{ trans.repeatPassword }}</label>

          <div class="button position-relative">
            <Field
              id="repeatPassword"
              v-model="subscriberInformation.repeatPassword"
              :type="showRepeatPassword ? 'text' : 'password'"
              aria-describedby="repeatPassword"
              class="form-control"
              name="repeatPassword"
              type="password"
            />
            <button :disabled="subscriberInformation.repeatPassword.length <= 0"
                    class="btn p-8 password-button"
                    @click="showRepeatPassword = !showRepeatPassword">
            <span :class="{'icon-eye-hide': showRepeatPassword,'icon-eye': !showRepeatPassword}"
                  class="icon"></span>
            </button>
          </div>

          <ErrorMessage class="invalid-feedback" name="repeatPassword"/>
        </div>

        <p v-if="errorMessage?.length > 0" class="error mb-12 d-block text-md">
          {{ errorMessage }}
        </p>

        <p v-if="successMessage?.length > 0" class="mb-12 d-block text-md">
          {{ successMessage }}
        </p>

        <div class="submit-section mb-16">
          <button
            :disabled="disabledButton || loading"
            class="btn btn-primary w-100 mb-8 mt-12 py-12"
            type="button"
            @click="handleSubmit($event, saveChanges)">
            {{ trans.saveChanges ?? 'Save Changes' }}
          </button>
        </div>
      </div>
    </Form>
  </div>
</template>

<script>
import { ErrorMessage, Field, Form } from 'vee-validate';
import * as yup from 'yup';
import api from '@assets/js/front/checkout/api';

export default {
  name: 'VChangeUserPassword',
  components: {
    Form,
    Field,
    ErrorMessage,
  },
  emits: ['saved'],
  props: {
    trans: {
      required: true,
    },
    locale: {
      required: true,
      type: String,
    },
  },
  data() {
    return {
      subscriberInformation: {
        oldPassword: '',
        newPassword: '',
        repeatPassword: '',
      },

      loading: false,

      showOldPassword: false,
      showNewPassword: false,
      showRepeatPassword: false,

      schema: {},
      successMessage: '',
      errorMessage: '',
    };
  },
  computed: {
    disabledButton() {
      return !this.subscriberInformation.oldPassword && !this.subscriberInformation.newPassword && !this.subscriberInformation.repeatPassword;
    },
  },
  async mounted() {
    const spanish = {
      mixed: {
        required: 'El campo es obligatorio',
        oneOf: 'Las contraseñas no coinciden',

      },
      string: {
        matches: 'Debe ser de al menos 8 carácteres, uno en mayúsculas, uno en minúsculas, un número y un carácter especial',
      },
    };

    const english = {
      mixed: {
        required: 'The field is required',
        oneOf: 'Passwords must match',

      },
      string: {
        matches: 'Must be at least 8 characters, one uppercase, one lowercase, one number and one special character',
      },
    };

    yup.setLocale(this.locale === 'es' ? spanish : english);

    this.schema = yup.object().shape({
      oldPassword: yup.string().required().label('oldPassword'),
      newPassword: yup.string().required().label('newPassword')
        .matches(
          // eslint-disable-next-line max-len
          /(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@!%*?&!"£$%^&*()_+{}:@~<>?|=[\];'#,./\\-])[A-Za-z\d$@!%*?&!"£$%^&*()_+{}:@~<>?|=[\];'#,./\\-]{8,}/,
        ),
      repeatPassword: yup.string().required().label('repeatPassword')
        .oneOf([yup.ref('newPassword'), null]),
    });
  },
  methods: {
    async saveChanges(formData) {
      this.errorMessage = '';
      this.successMessage = '';

      try {
        this.loading = true;

        let data = {
          current_password: formData.oldPassword,
          password: formData.newPassword,
          password_confirmation: formData.repeatPassword,
        };

        await api.user.updatePassword(data);
        this.successMessage = this.trans.changedDataSuccessfully ?? 'Changed successfully.';

      } catch (e) {

        if (!!e.response?.data?.message) {
          this.errorMessage = e.response?.data?.message;
        }

        console.error(e);
        throw e;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.user-change-password {
  input {
    padding-inline: 1rem !important;
  }
}
</style>
